export default __webpack_public_path__ + "static/media/checkmark-shape.04213a1b.svg";